import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router  } from '@angular/router';
import { UserService } from '../../services/user/user.service';
import { FormGroup, Validators, FormControl } from '@angular/forms';

@Component({
  selector: 'app-active-page',
  templateUrl: './active-page.component.html',
  styleUrls: ['./active-page.component.scss']
})
export class ActivePageComponent implements OnInit {
  public form: FormGroup;
  public loading = false;
  public errorMessage?: string;
  public attemptedSubmit = false;
  public successfullySent = false;

  private token: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService
  ) { }

  async ngOnInit() {
    this.route.queryParams.subscribe(this.onRouteParameterChange.bind(this));

    var a = await this.userService.active(this.token);
    console.log(a);

  }

  onRouteParameterChange(params) {
    if (!params || !params.token) {
      return this.router.navigate(['/login']);
    }
    this.token = params.token;
  }


  redirectToLogin() {
    console.log('Redirecting to login');
    this.router.navigate(['/login']);
  }
}
